import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { SitesQuery, SitesQuery$data } from '../../graphQLOperations/__generated__/SitesQuery.graphql';
import { sitesQuery } from '../../graphQLOperations/Sites';
import { useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';

interface Props {
  setSitesData: Dispatch<SetStateAction<SitesQuery$data | null>>;
  fetchKey: number;
  setRefetchingData: Dispatch<SetStateAction<boolean>>;
}

const QuerySites: FC<Props> = ({ setSitesData, fetchKey, setRefetchingData }) => {
  const userRedux = useAppSelector(selectUser);

  const data = useLazyLoadQuery<SitesQuery>(
    sitesQuery,
    {
      sitesFilter: {
        userId: `UserNode:${userRedux?.id}`,
      },
    },
    { fetchPolicy: 'network-only', fetchKey },
  );

  useEffect(() => {
    if (data) {
      setSitesData(data);
      setRefetchingData(false);
    }
  }, [data]);

  return <div style={{ display: 'none' }}></div>;
};

export default QuerySites;
